// extracted by mini-css-extract-plugin
export default {"bloc":"album2_bloc__j6f-i","texte_1":"album2_texte_1__MuIeI","texte_2":"album2_texte_2__yjHKB"};